<template>
	<div>
		  <Breadcrumbs main="Product" title="Edit Product" />
			 <div class="container-fluid">
				<div class="row">
				   <div class="col-sm-12">
					  <div class="card">
						 <div class="card-body">
 
							<div class="row mb-3">
							   	<div class="col-12">
									<router-link to="/products" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
									<!-- <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a> -->
							   	</div>
							</div>
 
							<form  @submit.prevent="editProduct()" enctype="multipart/form-data">
								<div class="form theme-form">
									<div class="row">
										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Product Name<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="product_name"/>
												<span v-if="errors.name">
													{{ errors.name[0] }}
												</span>
											</div>
										</div>

										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Product Image<span class="text-danger">*</span></label>
												<input class="form-control" type="file" placeholder="Product Image" @change="handleFileChange"/>
												<span v-if="errors.image">
													{{ errors.image[0] }}
												</span>
											</div>
										</div>
										
									</div>

									<div class="row mt-3">
										<div class="col-sm-12">
											<button class="btn btn-success me-2 float-end" type="submit">Save</button>
										</div>
									</div>
	
								</div>
							</form>
						 </div>
					  </div>
				   </div>
				</div>
			 </div>
 
	</div>
 </template>

<script setup>
import { onMounted, ref } from 'vue';
import { routes } from '@/constants/routes';
import { get, post } from '@/utils/api';
import { useRouter, useRoute } from 'vue-router';
import Swal from '@/utils/swal';

const router = useRouter();
const route = useRoute();

const product_id = route.query.id;
const product_name = ref('');
const product_image = ref('');
let errors = ref({});

const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    product_image.value = file;
  }
};

const fetchProduct = () => {

	const params = {
		id: product_id
	}

	get(routes.ProductDetail, { params }, false)
	.then((response) => {
	if (response.status === 200) {
		console.log(response.data.data);
		product_name.value = response.data.data.product_name;
	} else {
		Swal.fire('', response.data.message || 'Error fetching data', 'error');
	}
	})
	.catch((error) => {
	if (error.response?.status === 422) {
		Swal.fire('', error.response.data.message || 'Validation error', 'error');
	} else if (error.response?.status === 500) {
		Swal.fire('', error.response.statusText || 'Server error', 'error');
	} else if (error.response?.status === 401) {
		Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
		router.push({ name: 'login' });
	} else {
		Swal.fire('', error.response.data?.message || 'Error occured', 'error');
	}
	});

};

const editProduct = () => {

	const formData = new FormData();
	formData.append('product_id', product_id);
	formData.append('name', product_name.value);
	if(product_image.value){
		formData.append('image', product_image.value);
	}

	post(routes.UpdateProduct, formData, false)
		.then((response) => {
			if (response.status === 200) {
				Swal.fire('', response.data.message || 'Product updated successfully', 'success');
				router.push({ name: 'products' });
			} else {
				Swal.fire('', response.data.message || 'Failed to update product', 'error');
			}
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				errors.value = error.response.data.message;
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		})

};

onMounted(() => {
	fetchProduct();
})
 

</script>